const Scroll = function Scroll () {

    this.to = function (target, options) {
        target = target || '.message-to-read';

        this.options = Object.assign({
            offset: 30,
            easing: 'swing',
        }, options);

        return new Promise((resolve, reject) => {
            if (typeof Vue !== 'undefined') {
                return Vue.nextTick().then(() => {
                    return this.process(target, resolve, reject);
                })
            } else {
                return setTimeout(() => {
                    return this.process(target, resolve, reject);
                }, 100);
            }
        });
    };

    this.process = function (target, resolve, reject) {
        this.element = jQuery(target);

        if (!this.element.length) {
            return reject(`Scroll triggered - but could not find ${target}`);
        }

        if (!this.elementIsInView()) {
            return jQuery('html, body').animate({
                scrollTop: this.element.offset().top - this.options.offset,
                complete: () => {
                    return resolve(this.element);
                },
            }, 400, this.easing);
        }

        return resolve(this.element);
    };

    this.elementIsInView = function () {
        const minBoundry = window.scrollY;
        const maxBoundry = window.scrollY + window.innerHeight;

        return (
            this.element.offset().top > minBoundry &&
            this.element.offset().top < maxBoundry
        );
    };

};

export default new Scroll();


// WEBPACK FOOTER //
// ./web/app/themes/giles/resources/js/giles-ui/ScrollTo/index.js